// extracted by mini-css-extract-plugin
export default {"root":"QuoteItem__root--jT3lg","left":"QuoteItem__left--Rfvcg","row-title":"QuoteItem__row-title--iJxGP","rowTitle":"QuoteItem__row-title--iJxGP","right":"QuoteItem__right--qeCUW"};